module.exports = __webpack_public_path__ + "static/media/Recursion.3fbc28e3.jpg";